import { isEqual } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { useAiFieldHint, useAiFormFill } from '../AiFormFillContext';
import { FormValues } from '../FormWrapper';

export const useLedgerDateAiHint = () => {
  const { watch } = useFormContext<FormValues>();
  const startDateHint = useAiFieldHint('startDate');
  const apportionmentModeHint = useAiFieldHint('apportionmentMode');
  const endDateHint = useAiFieldHint('endDate');
  const { originalValues, revertField } = useAiFormFill();

  const currentStartDate = watch('startDate');
  const currentEndDate = watch('endDate');
  const currentApportionmentMode = watch('apportionmentMode');
  const currentApportionmentBasis = watch('apportionmentBasis' as any);

  const hasDateOriginal =
    'startDate' in originalValues ||
    'endDate' in originalValues ||
    'apportionmentMode' in originalValues ||
    'apportionmentBasis' in originalValues;

  const isDateModified =
    ('startDate' in originalValues &&
      !isEqual(currentStartDate, originalValues.startDate)) ||
    ('endDate' in originalValues &&
      !isEqual(currentEndDate, originalValues.endDate)) ||
    ('apportionmentMode' in originalValues &&
      !isEqual(currentApportionmentMode, originalValues.apportionmentMode)) ||
    ('apportionmentBasis' in originalValues &&
      !isEqual(currentApportionmentBasis, originalValues.apportionmentBasis));

  const handleRevertDateFields = () => {
    if ('startDate' in originalValues) {
      revertField('startDate');
    }
    if ('endDate' in originalValues) {
      revertField('endDate');
    }
    if ('apportionmentMode' in originalValues) {
      revertField('apportionmentMode');
    }
    if ('apportionmentBasis' in originalValues) {
      revertField('apportionmentBasis' as any);
    }
  };

  return {
    confidence:
      startDateHint?.confidence ??
      apportionmentModeHint?.confidence ??
      endDateHint?.confidence,
    reason:
      startDateHint?.reason ??
      apportionmentModeHint?.reason ??
      endDateHint?.reason,
    isModified: isDateModified,
    onRevert: hasDateOriginal ? handleRevertDateFields : undefined,
    currentStartDate,
  };
};
